const Table = ELEMENT.Table;

if (!Table.render_override) {
  const render = Table.render;
  const created = Table.created;
  const doLayout = Table.methods.doLayout;
  Table.created = function () {
    this._scrollPosition = this.scrollPosition;
    //覆盖原有的updateElsHeight函数
    this.layout.updateElsHeight = tableLayoutUpdateElsHeight;
    created.call(this);
  };
  Table.methods.doLayout = function () {
    doLayout.call(this);
    this.$nextTick(() => {
      this.splitTableFooter()
      this.setFixelSize()
    });
  };
  Table.methods.setFixelSize=setFixelSize;
  Table.methods.splitTableFooter=splitTableFooter;
  Table.methods.syncPostion=syncPostion;
  Table.render = function (h) {
    let vnodes = render.call(this, h);
    if (vnodes.children) {
      //修复el-table存在汇总行和固定行头时el-table__fixed遮挡滚动条的问题
      let index = _.findIndex(vnodes.children, (vn) => {
        return vn?.data?.staticClass == "el-table__fixed";
      });
      let fixed = vnodes.children[index];
      if (fixed) {
        let footer = _.find(fixed.children || [], (it) => it?.data?.staticClass == "el-table__fixed-footer-wrapper");
        if (footer) {
          dsf.array.remove(fixed.children, footer);
          let footerVnode = (
            <div ref="fixedWrapperFooter" class="el-table__fixed_footer">
              {footer}
            </div>
          );
          vnodes.children.splice(index + 1, 0, footerVnode);
        } else {
          this.$nextTick(() => {
            this.setFixelSize()
          });
        }
      }

      // let headerWrapper = _.find(vnodes.children, (vn) => {
      //   return vn?.data?.ref == "headerWrapper";
      // });
      // if (headerWrapper) {
      //   let fixedWrapper = _.find(vnodes.children, () => {
      //     return vn?.data?.ref == "fixedWrapper";
      //   });
      //   if (fixedWrapper) {
      //     let fixedHeaderWrapper = _.find(fixedWrapper.children, () => {
      //       return vn?.data?.ref == "fixedHeaderWrapper";
      //     });
      //     if (fixedHeaderWrapper?.data?.style) {
      //       _.each(fixedHeaderWrapper?.data?.style, (s) => {
      //         if (s.top) {
      //           // s.top=
      //         }
      //       });
      //     }
      //   }
      // }
    }
    return vnodes;
  };
  Table.render_override = true;
}
//重写table.layout中的更新元素高度函数,由于平台修正过el-table的边框样式，而其本身计算高度时为计算边框高度导致后续的高度会产生错误
function tableLayoutUpdateElsHeight() {
  if (!this.table.$ready) return Vue.nextTick(() => this.updateElsHeight());
  const { headerWrapper, appendWrapper, footerWrapper } = this.table.$refs;
  this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;

  if (this.showHeader && !headerWrapper) return;

  // fix issue (https://github.com/ElemeFE/element/pull/16956)
  const headerTrElm = headerWrapper ? headerWrapper.querySelector(".el-table__header tr") : null;
  const noneHeader = this.headerDisplayNone(headerTrElm);
  // const headerHeight = (this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight);
  let scale = (window.$designerSscale || 100) / 100;
  const headerHeight = (this.headerHeight = !this.showHeader ? 0 : Math.round(headerWrapper.getBoundingClientRect().height / scale));
  if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
    return Vue.nextTick(() => this.updateElsHeight());
  }
  const tableHeight = (this.tableHeight = this.table.$el.getBoundingClientRect().height || this.table.$el.clientHeight);
  const footerHeight = (this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0);
  if (this.height !== null) {
    this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
  }
  this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;

  const noData = !(this.store.states.data && this.store.states.data.length);
  this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;

  this.updateScrollY();
  this.notifyObservers("scrollable");
}

function splitTableFooter() {
  if (this.$refs?.fixedWrapperFooter) {
    let fixedHeaderHeight = this?.$refs?.fixedHeaderWrapper?.offsetHeight || 0;
    let fixedBodyHeight = this?.$refs?.fixedBodyWrapper?.offsetHeight || 0;
    let fixed = this.$refs.fixedWrapper;
    if (fixed) {
      this.$refs.fixedWrapper.style.height = this.unitSize(fixedHeaderHeight + fixedBodyHeight + 2);
      this.$refs.fixedWrapperFooter.style.width = this.unitSize(this.$refs.fixedWrapper.offsetWidth);
      this.$refs.fixedWrapperFooter.style.height = this.unitSize(this.$refs.fixedFooterWrapper.offsetHeight);
    }
  }
}

function setFixelSize() {
  let scrollHeight = 0;
  let totalHeight = this.layout?.tableHeight || 0;
  if (this.layout && this.layout.scrollX) {
    scrollHeight = this.layout.gutterWidth;
  }
  // if (!totalHeight?.toString()?.includes('.')) {
  //   if (scrollHeight) {
  //     if (this.$refs?.fixedWrapper?.style?.height) {
  //       this.$refs.fixedWrapper.style.height = this.unitSize(totalHeight - scrollHeight);
  //     }
  //     if (this.$refs?.rightFixedWrapper?.style?.height) {
  //       this.$refs.rightFixedWrapper.style.height = this.unitSize(totalHeight - scrollHeight);
  //     }
  //   }
  // }
  // // 如果高度是小数需要修正
  // else {
  if (!dsf.client.isMac() && scrollHeight) {
    scrollHeight -= 1;
  }
  if (this?.$refs?.fixedWrapper?.getBoundingClientRect) {
    this.$refs.fixedWrapper.style.height = "auto";
    this.$refs.fixedWrapper.style.bottom = scrollHeight + "px";
    setTimeout(() => {
      if (this.$refs.fixedWrapper) {
        let height = this.$refs.fixedWrapper.getBoundingClientRect().height;
        this.$refs.fixedWrapper.style.height = height + "px";
      }
    });
  }
  if (this?.$refs?.rightFixedWrapper?.getBoundingClientRect) {
    this.$refs.rightFixedWrapper.style.height = "auto";
    this.$refs.rightFixedWrapper.style.bottom = scrollHeight + "px";
    setTimeout(() => {
      if (this.$refs.rightFixedWrapper) {
        let height = this.$refs.rightFixedWrapper.getBoundingClientRect().height;
        this.$refs.rightFixedWrapper.style.height = height + "px";
      }
    });
  }
  // }
}

const throttleSyncPostion = _.throttle(function() {
  _syncPosition.call(this);
}, 16)

function _syncPosition() {
  const { scrollX, scrollY, gutterWidth } = this.layout;
  const { scrollLeft, scrollTop, offsetWidth, scrollWidth } = this.bodyWrapper;
  const { headerWrapper, footerWrapper, fixedBodyWrapper, rightFixedBodyWrapper } = this.$refs;
  if (headerWrapper) headerWrapper.scrollLeft = scrollLeft;
  if (footerWrapper) footerWrapper.scrollLeft = scrollLeft;
  if (fixedBodyWrapper) fixedBodyWrapper.scrollTop = scrollTop;
  if (rightFixedBodyWrapper) rightFixedBodyWrapper.scrollTop = scrollTop;
  if (scrollX) {
    let maxScrollLeftPosition = scrollWidth - offsetWidth - 1;
    if (scrollY) {
      maxScrollLeftPosition += gutterWidth;
    }
    let _scrollPosition = 'middle';
    if (scrollLeft >= maxScrollLeftPosition) {
      _scrollPosition = 'right';
    } else if (scrollLeft === 0) {
      _scrollPosition = 'left';
    }
    if (_scrollPosition !== this._scrollPosition) {
      setTimeout(() => {
        let classList = this.bodyWrapper.classList;
        classList.remove(`is-scrolling-${this._scrollPosition}`);
        classList.add(`is-scrolling-${this._scrollPosition = _scrollPosition}`);
      });
    }
  }
}

function syncPostion(evt) {
  let raf = window.requestAnimationFrame;
  if (!raf) {
    throttleSyncPostion.call(this);
  } else {
    raf(_syncPosition.bind(this));
  }
}